import React from 'react';
import { StaticImageData } from 'next/image';
import Link from 'components/commercetools-ui/atoms/link';
import Slider from 'components/commercetools-ui/atoms/slider';
import Typography from 'components/commercetools-ui/atoms/typography';
import useWindowWidth from 'helpers/hooks/useBrowerWidth';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { breakpoints } from 'helpers/utils/breakpoints';
import {
  desktop,
  hugeDesktop,
  largeDesktop,
  mediumDesktop,
  minitablet,
  mobile,
  tablet,
} from 'helpers/utils/screensizes';
import { Reference } from 'types/reference';
import Image from 'frontastic/lib/image';

export interface ProductProps {
  data: any;
  title: string;
}

type slideType = {
  additional_css: string;
  ctas: { button: { href: string } }[];
  card_title?: string;
  image: { url: string | StaticImageData; title?: string };
  call_to_action: { href: string | Reference };
};

const Product: React.FC<ProductProps> = ({ data, title }) => {
  const [isTabletSize] = useMediaQuery(tablet);
  const [isMiniTabletSize] = useMediaQuery(minitablet);
  const width = useWindowWidth();

  const Title = data?.header?.section_title;
  const cmsCssClass = data?.header?.additional_css;

  return (
    <div className="product-section bg-white">
      <div className={`3xl:px-80 pl-24 pt-48 md:px-28 lg:px-48 xl:px-60 xl:pt-60 2xl:px-[61px] 2xl:pt-80 ${cmsCssClass}`}>
        <div className="flex items-center justify-between pr-4">
          <Typography className="!mb-36 text-32 font-medium leading-4 text-[#090909] md:!mb-48 xl:leading-4 2xl:text-[48px] 2xl:leading-[13px]">
            {Title}
          </Typography>
        </div>

        <Slider
          allowTouchMove
          autoplay={{
            // delay: 5000,
            // disableOnInteraction: false,
          }}
          arrows={false}
          dots={width !== null && width >= 600}
          innerArrows
          allowArrowsOnTouchDevice
          solidArrows
          nextButtonStyles={{ top: '120%', left: 50 }}
          prevButtonStyles={{ top: '120%', left: 0 }}
          slidesPerView={2.5}
          spaceBetween={16}
          breakpoints={{
            [mobile]: {
              slidesPerView: 4.15,
              spaceBetween: 16,
              ...(breakpoints[mobile] ?? {}),
            },
            [tablet]: {
              slidesPerView: 6,
              spaceBetween: 16,
              ...(breakpoints[tablet] ?? {}),
            },
            [desktop]: {
              slidesPerView: 7,
              spaceBetween: 16,
              ...(breakpoints[desktop] ?? {}),
            },
            [mediumDesktop]: {
              slidesPerView: 8,
              spaceBetween: 16,
              ...(breakpoints[mediumDesktop] ?? {}),
            },
            [largeDesktop]: {
              slidesPerView: 9,
              spaceBetween: 16,
              ...(breakpoints[largeDesktop] ?? {}),
            },
            [hugeDesktop]: {
              slidesPerView: 9,
              spaceBetween: 16,
              ...(breakpoints[hugeDesktop] ?? {}),
            },
          }}
        >
          {data?.card_header_button_section?.map((slide: slideType, index: number) => (
            <Link key={`slide-${index}`} link={slide?.ctas?.[0]?.button?.href} onClick={(e) => e.stopPropagation()}>
              <div
                key={index}
                className={`custom-hover bg-color bd-r flex flex-col items-center p-16 lg:bg-[#FFFFFF] ${slide?.additional_css}`}
              >
                <div className="" key={index}>
                  <Image
                    loading="lazy"
                    src={slide.image.url}
                    alt={slide.image.title || 'Default alt text'}
                    fill
                    style={{ objectFit: 'cover' }}
                    className="!relative !h-80 !w-[65px]"
                  />
                </div>
                {slide?.card_title && (
                  <Typography
                    className={`!relative mt-[12px] flex flex-col text-ellipsis pt-[12px] text-center text-[16px] font-medium leading-[25px] text-[#090909] md:text-[16px] lg:text-[20px] xl:text-[18px] 2xl:text-[22px]  ${
                      width !== null && width < 375 ? 'min-h-[85px]' : 'min-h-[85px]'
                    } ${width !== null && width < 1023 ? 'min-h-[60px]' : 'min-h-[85px]'}`}
                  >
                    {slide.card_title}
                  </Typography>
                )}
              </div>
            </Link>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Product;
